import { useState } from "react";
import cls from "./find-record.module.css";
import FormModal from "../FormModal/FormModal";
import GridView from "../GridView/GridView";
import { MenuItem } from "../../../models/menu";
import { Result } from "../../../models/interfaces";
import { MdSearch } from "react-icons/md";

export interface FindRecordProps<T> {
  id: string;
  text?: string;
  contextMenu?: MenuItem<T>[];
  onSelectRecord?: (record: T | undefined) => void;
  getRecords?: () => Promise<Result<T[]>>;
  hideColumns?: string[];
  value?: T;
}

export type dataType = "text" | "number";

function FindRecord<T>(props: FindRecordProps<T>) {
  const [showModal, setShowModal] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState<T>();

  const toggleModal = () => setShowModal(!showModal);
  console.log("modalValue " + showModal);

  return (
    <div className="form-group">
      <label htmlFor={props.id} className="control-label">
        {props.text}
      </label>
      <div className="input-group">
        <input
          type="text"
          name={props.id}
          id={props.id}
          className="form-control form-control-sm"
          readOnly={true}
        />

        {selectedRecord !== undefined && (
          <button
            type="button"
            title="Clear Selected Account"
            className={
              "btn btn-outline-secondary input-group-btn " + cls.clearButton
            }
            onClick={(e) => {
              setSelectedRecord(undefined);
              props.onSelectRecord?.(undefined);
            }}
          >
            <span className={"btn-close " + cls.clearButton}></span>
          </button>
        )}
        <button
          title="Search"
          className="btn btn-secondary input-group-btn btn-sm"
          type="button"
          onClick={(e) => {
            toggleModal();
          }}
        >
          <MdSearch size={20} />
        </button>
      </div>

      {showModal && (
        <FormModal onClose={toggleModal} size="large">
          <GridView<T>
            name={"lst_" + props.id}
            rowsPerPage={20}
            showSearchBar={true}
            onRecordSelected={(record) => {
              setSelectedRecord(record);
              toggleModal();
              props.onSelectRecord?.(record);
            }}
          />
        </FormModal>
      )}
    </div>
  );
}

export default FindRecord;
